import React, { useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";

export const CustomerMenuItems = [
  {
    header: "تنظیمات",
    headerIcon: SettingsIcon,
    items: [
      {
        name: "کارمند ها",
        route: "/setting-employee",
        isActive: "employee",
      },
      {
        name: "تنظیمات نمایش",
        route: "/setting-set-parameter",
        isActive: "parameter",
      },
    ],
  },
  {
    header: "سفارش‌ها",
    headerIcon: ShoppingBasketIcon,
    items: [
      {
        name: "ثبت سفارش",
        route: "/create-order",
        isActive: "create-order",
      },
      {
        name: "پیش سفارش‌ها",
        route: "/pre-orders",
        isActive: "pre-orders",
      },
      {
        name: "سفارش‌های ثبت شده",
        route: "/new-orders",
        isActive: "new-orders",
      },
      {
        name: "سفارش‌های جاری",
        route: "/current-orders",
        isActive: "current-orders",
      },
      {
        name: "سفارش‌های تحویل گرفته‌شده",
        route: "/recevied-orders",
        isActive: "recevied-orders",
      },
      {
        name: "سفارش‌های لغو ‌شده",
        route: "/cancelled-orders",
        isActive: "cancelled-orders",
      },
    ],
  },
  {
    header: "مرجوعی",
    headerIcon: AssignmentReturnIcon,
    items: [
      {
        name: "ثبت مرجوعی",
        route: "/returned-order",
        isActive: "returned-order",
      },
      {
        name: "لیست مرجوعی",
        route: "/returned-order-list",
        isActive: "returned-order-list",
      },
    ],
  },

  {
    header: "پیام رسان",
    headerIcon: EmailIcon,
    items: [],
    route: "/messages",
  },
  {
    header: "گفتگوها",
    headerIcon: TelegramIcon,
    items: [],
    route: "/chats",
    haveBadge: true,
  },
];
